export const warehouseSearchParams = {
  serviceDetail: {
    orders: 'orders',
  },
  directSaleDetail: {
    directSale: 'directSale',
  },
};
